export const rolePermissions = {
  dashboard: {
    view: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer'],
    viewSettlement: ['AdminUser', 'SubAdmin', 'Operation']
  },

  businessKYC: {
    view: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation'],
    upgrade: ['AdminUser']
  },

  paymentLink: {
    create: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation'],
    share: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer']
  },
  chargeBack: {
    viewChargeback: ['AdminUser', 'SubAdmin', 'Operation', 'Cashier'],
    downloadChargeBackReport: ['AdminUser', 'SubAdmin', 'Operation']
  },
  referrals: {
    view: ['AdminUser', 'SubAdmin', 'Operation', 'Cashier']
  },

  staticWallet: {
    createWallet: ['AdminUser', 'SubAdmin', 'Operation'],
    manageWallet: ['AdminUser', 'SubAdmin', 'Operation'],
    viewTransactions: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ]
  },

  transactions: {
    viewHistory: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer'],
    downloadReport: ['AdminUser', 'SubAdmin', 'Operation'],
     refund: ['AdminUser', 'SubAdmin']
  },

  withdrawals: {
    viewBalance: ['AdminUser', 'SubAdmin', 'Operation'],
    transferHistory: ['AdminUser', 'SubAdmin', 'Operation'],
    withdraw: ['AdminUser', 'SubAdmin']
  },

  splitPayment: {
    createPlan: ['AdminUser', 'SubAdmin'],
    view: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer'],
    manageSplit: ['AdminUser', 'SubAdmin', 'Operation']
  },

  userRoleHub: {
    viewUsers: ['AdminUser', 'SubAdmin', 'Operation'],
    createUser: ['AdminUser', 'SubAdmin'],
    editUser: ['AdminUser', 'SubAdmin'],
    deleteUser: ['AdminUser', 'SubAdmin']
  },

  businessSettings: {
    viewBusiness: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ],
    editProfileInformation: ['AdminUser'],
    manageApiKeys: ['AdminUser', 'SubAdmin', 'Developer'],
    addBusiness: ['AdminUser'],
    viewSubAccounts: ['AdminUser', 'SubAdmin', 'Operation'],
    manageSubAccounts: ['AdminUser', 'SubAdmin'],
    editBusiness: ['AdminUser', 'SubAdmin', 'Developer'],
    managePin: ['AdminUser', 'SubAdmin', 'Developer'],
    editBusinessForm: ['AdminUser']
  },
  storefront: {
    viewStorefront: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer'],
    createStorefront: ['AdminUser', 'SubAdmin', 'Operation']
  },

  product: {
    createProduct: ['AdminUser', 'SubAdmin', 'Operation'],
    manageProduct: ['AdminUser', 'SubAdmin', 'Operation'],
    createProductCategory: ['AdminUser', 'SubAdmin', 'Operation'],
    manageProductCategory: ['AdminUser', 'SubAdmin', 'Operation'],
    viewArchivedProducts: ['AdminUser', 'SubAdmin', 'Operation'],
    viewProducts: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer']
  },

  orders: {
    viewOrders: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer'],
    manageOrders: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation', 'Developer']
  },

  shipping: {
    manageDeliveryLocations: [
      'AdminUser',
      'SubAdmin',
      'Operation',
      'Developer'
    ],
    managePickupLocations: ['AdminUser', 'SubAdmin', 'Operation', 'Developer'],
    viewLocations: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation'
    ]
  },

  customers: {
    viewCustomers: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation'
    ],
    exportCustomerDetails: ['AdminUser', 'SubAdmin', 'Operation', 'Developer'],
    manageCustomers: ['AdminUser', 'SubAdmin', 'Operation', 'Developer']
  },

  invoice: {
    createInvoice: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ],
    manageInvoice: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ],
    viewInvoice: ['AdminUser', 'SubAdmin', 'Cashier', 'Operation']
  },

  storeSettings: {
    previewStorefront: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ],
    editStorefront: ['AdminUser', 'SubAdmin', 'Operation'],
    viewReviewsRatings: [
      'AdminUser',
      'SubAdmin',
      'Cashier',
      'Operation',
      'Developer'
    ],
    addFaqs: ['AdminUser', 'SubAdmin', 'Operation'],
    manageFaqs: ['AdminUser', 'SubAdmin', 'Operation'],
    deactivateStore: ['AdminUser', 'SubAdmin', 'Operation']
  }
};
